import { render, staticRenderFns } from "./ReturnedList.vue?vue&type=template&id=5ea11572&"
import script from "./ReturnedList.vue?vue&type=script&lang=js&"
export * from "./ReturnedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports